import VTooltip from "v-tooltip";
// Notifications plugin
import { NotificationsPlugin, SidebarPlugin } from "@/core/utils/index";
// A plugin file where you could register global components used across the app
import GlobalComponents from "@/globalComponents";
// A plugin file where you could register global directives
import GlobalDirectives from "@/globalDirectives";

// asset imports

/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SidebarPlugin);
    Vue.use(NotificationsPlugin);
    Vue.use(VTooltip);
  },
};
